import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBagIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("first-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().top < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-34" data-mp="2ft3b8os2lgco">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-petal bg-white/95 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-35" data-mp="2avl493xm5b7b">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl bg-cta px-4 py-4 text-[16px] font-extrabold uppercase tracking-wide text-white shadow-[0_10px_24px_-8px_rgba(22,163,74,0.8)] transition-colors duration-150 hover:bg-ctaDark" data-id="element-36" data-mp="2z425k4xp12ug">
            <ShoppingBagIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-37" data-mp="2fdp04mcd2li0" />
            Get instant access for $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}